/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespLayout_viewer = {
    readonly user?: {
        readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_user" | "PdpSharedLayout_user">;
    } | null | undefined;
    readonly itemRead: ReadonlyArray<{
        readonly serviceId?: string | null | undefined;
        readonly displayInfo?: {
            readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_displayInfo">;
        } | null | undefined;
        readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_item">;
    } | null> | null;
    readonly similarLandingItems?: {
        readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_similarLandingItems">;
    } | null | undefined;
    readonly relevantShipping: {
        readonly shipmentQuote: {
            readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_shipmentQuote">;
        } | null;
        readonly shipment: {
            readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_shipment">;
        } | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_viewer" | "PdpSharedLayout_viewer">;
    readonly " $refType": "PdpRespLayout_viewer";
};
export type PdpRespLayout_viewer$data = PdpRespLayout_viewer;
export type PdpRespLayout_viewer$key = {
    readonly " $data"?: PdpRespLayout_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespLayout_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
},
v1 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "clickabilityVariant"
    },
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "itemIds"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespLayout_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itemIds",
          "variableName": "itemIds"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "itemRead",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_item"
            },
            {
              "condition": "isClient",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "alias": null,
                  "args": [
                    (v0/*: any*/),
                    {
                      "kind": "Literal",
                      "name": "page",
                      "value": "pdp"
                    }
                  ],
                  "concreteType": "ItemDisplayInfo",
                  "kind": "LinkedField",
                  "name": "displayInfo",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PdpRespContainer_displayInfo"
                    }
                  ],
                  "storageKey": null
                }
              ]
            }
          ],
          "type": "Item",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "concreteType": "RelevantShippingInfo",
      "kind": "LinkedField",
      "name": "relevantShipping",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ShipmentQuote",
          "kind": "LinkedField",
          "name": "shipmentQuote",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_shipmentQuote"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Shipment",
          "kind": "LinkedField",
          "name": "shipment",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_shipment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespContainer_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedLayout_viewer"
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedLayout_user"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "similarLandingItems",
          "args": [
            {
              "kind": "Variable",
              "name": "clickabilityVariant",
              "variableName": "clickabilityVariant"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 12
            },
            {
              "kind": "Variable",
              "name": "isTrade",
              "variableName": "isTrade"
            },
            (v1/*: any*/),
            {
              "kind": "Literal",
              "name": "rerankDocs",
              "value": 50
            },
            {
              "kind": "Literal",
              "name": "rerankQueryTemplate",
              "value": "CLICKABILITY_SCORE"
            }
          ],
          "concreteType": "moreLikeThisItemConnection",
          "kind": "LinkedField",
          "name": "moreLikeThisItem",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_similarLandingItems"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();
(node as any).hash = '73a25bbec7617bbaca52b3f12d552e16';
export default node;
